import {
  call,
  put,
  select,
  takeLatest,
} from 'redux-saga/effects';

import { get } from '../../utils/request';
import { FETCH_DISCLOSURE, INVALID_DISCLOSURE_MESSAGE } from './constants';
import { fetchDisclosureFailure, fetchDisclosureSuccess } from './actions';
import { selectDisasterAssistanceDisclosurePhoneNumber } from './selectors';

export function* fetchDisclosureSaga({ baseUrl }, { payload }) {
  try {
    const { disclosureName, language } = payload;
    let queryParamsString = '';
    if (disclosureName === 'disasterassistancestep3') {
      const disasterAssistanceDisclosurePhoneNumber = yield select(
        selectDisasterAssistanceDisclosurePhoneNumber(),
      );
      // eslint-disable-next-line max-len
      queryParamsString = `?language=${language}&disasterAssistanceDisclosurePhoneNumber=${disasterAssistanceDisclosurePhoneNumber}`;
    } else {
      queryParamsString = `?language=${language}`;
    }
    const { disclosure } = yield call(
      get, `${baseUrl}/disclosures/${disclosureName}${queryParamsString}`,
    );
    if (disclosure) {
      yield put(fetchDisclosureSuccess({ disclosure, disclosureName }));
    } else {
      yield put(fetchDisclosureFailure(INVALID_DISCLOSURE_MESSAGE));
    }
  } catch (error) {
    yield put(fetchDisclosureFailure(INVALID_DISCLOSURE_MESSAGE));
  }
}

export default (options) => function* watcherSaga() {
  yield takeLatest(FETCH_DISCLOSURE, fetchDisclosureSaga, options);
};
